import { render, staticRenderFns } from "./TestMap.vue?vue&type=template&id=88897636&"
import script from "./TestMap.vue?vue&type=script&lang=js&"
export * from "./TestMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports